/** @jsxImportSource @emotion/react */
import { Color, useTheme } from "basis";
import { FC, ReactNode } from "react";

type Props = {
  bg?: Color;
  children: ReactNode;
};

export const MaxWidthContainer: FC<Props> = ({ bg, children }) => {
  const theme = useTheme();
  const content = (
    <div
      css={{
        [theme.minMediaQueries.xl]: {
          maxWidth: 1140,
          marginLeft: "auto",
          marginRight: "auto",
        },
      }}
    >
      {children}
    </div>
  );

  if (bg) {
    const css = {
      backgroundColor: theme.getColor(bg) ?? undefined,
    };
    return <div css={css}>{content}</div>;
  }

  return content;
};
